module.exports = __webpack_public_path__ + "img/skirt_3.6a95d1e4.png";